/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefInvitationData } from '../../models/api-def-invitation-data';
import { ApiDefOrganizationData } from '../../models/api-def-organization-data';
import { ApiDefUserData } from '../../models/api-def-user-data';

export interface OrganizationsAddOrInviteUser$Params {

/**
 * The ID of the organization
 */
  organizationId: string;
      body: (any | any)
}

export function organizationsAddOrInviteUser(http: HttpClient, rootUrl: string, params: OrganizationsAddOrInviteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'organization'?: ApiDefOrganizationData;
'user'?: ApiDefUserData;

/**
 * Indicates if an invitation email was sent
 */
'invitationSent'?: boolean;
'invitation'?: ApiDefInvitationData;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsAddOrInviteUser.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'organization'?: ApiDefOrganizationData;
      'user'?: ApiDefUserData;
      
      /**
       * Indicates if an invitation email was sent
       */
      'invitationSent'?: boolean;
      'invitation'?: ApiDefInvitationData;
      }>;
    })
  );
}

organizationsAddOrInviteUser.PATH = '/organizations/{organizationId}/users';
